import { render, staticRenderFns } from "./customerReviews.vue?vue&type=template&id=035fdca7&scoped=true&"
import script from "./customerReviews.vue?vue&type=script&lang=js&"
export * from "./customerReviews.vue?vue&type=script&lang=js&"
import style0 from "./customerReviews.vue?vue&type=style&index=0&id=035fdca7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035fdca7",
  null
  
)

export default component.exports